var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#","data-toggle":"control-sidebar"}},[_c('i',{staticClass:"fa fa-gears"})])])}]

export { render, staticRenderFns }